import { Injectable } from '@angular/core';
import { StorageSettings } from './storage.settings';
//import { AuthRequestOptions } from './authrequestoptions';
import { HttpClient as Http, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HttpClient {
    private http : Http;
    private storage: StorageSettings;
   // private baseOptions: AuthRequestOptions;

    constructor(http: Http, public _storage: StorageSettings, 
        //_baseOptions: AuthRequestOptions
        ) {
        this.http = http;
        this.storage = _storage;
        //this.baseOptions = _baseOptions;
    }

    setContentTypeHeader(options: any = {}): any {
       let headers = options && options.headers ? options.headers : new HttpHeaders(); 
       headers.append('content-type', 'application/json');
       options.headers = headers;
       return options;
    }

    /**
     * Performs any type of http request.
     */
    request(method: string, url?: string, options: any = {}) {
        options = this.setContentTypeHeader(options);
        //let req: HttpRequest<any> = new HttpRequest(method, url, options);
        return this.http.request(method, url, { headers: options.headers, responseType: options.responseType });
    }

    /**
     * Performs a request with `get` http method.
     */
    get(url: string, options: any = {}){
        options = this.setContentTypeHeader(options);

        return this.http.get(url, {observe: 'response', headers: options.headers, responseType: options.responseType});
    }

    getForType<T>(url: string, options: any = {}): Observable<HttpResponse<T>>{
        options = this.setContentTypeHeader(options);
        return this.http.get<T>(url, {observe: 'response', headers: options.headers, responseType: options.responseType});
    }

    /**
     * Performs a request with `post` http method.
     */
    post(url: string, body: any, options: any = {}) {
        options = this.setContentTypeHeader(options);
        return this.http.post(url, body, {observe: 'response', headers: options.headers, responseType: options.responseType});
    }

    /**
     * Performs a request with `put` http method.
     */
    put(url: string, body: any, options: any = {}){
        options = this.setContentTypeHeader(options);
        return this.http.put(url, body, options);
    }
    /**
     * Performs a request with `delete` http method.
     */
    delete(url: string, options: any = {}){
        options = this.setContentTypeHeader(options);
        return this.http.delete(url, options);
    }
    /**
     * Performs a request with `patch` http method.
     */
    patch(url: string, body: any, options: any = {}){
        options = this.setContentTypeHeader(options);
        return this.http.patch(url, body, options);
    }
    /**
     * Performs a request with `head` http method.
     */
    head(url: string, options: any = {}){
        options = this.setContentTypeHeader(options);
        return this.http.head(url, options);
    }
    /**
     * Performs a request with `options` http method.
     */
    options(url: string, options: any = {}){
        options = this.setContentTypeHeader(options);
        return this.http.options(url, options);
    }
}
